// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ErrorPage_pageWrapper__fr0hM","header":"ErrorPage_header__6+CjB","text":"ErrorPage_text__6TtGG","pageContent":"ErrorPage_pageContent__adKTy"};